import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { revenueApi } from "@/lib/api";

export const useReimportRevenueStatement = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => revenueApi.reimportRevenueStatement(id),
    // The statement comes back "generating"; the statement queries poll until it settles.
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: ["revenue-statements"] });
      queryClient.invalidateQueries({ queryKey: ["revenue-statement", id] });
    },
    onError: (error) => toast.error(error.message || "Failed to re-import statement"),
  });
};
